export default __webpack_public_path__ + "static/media/fi-br-arrow-left.d663732f.svg";